/* HFB-067 mobile navigation — live under 959px */
(function () {
  var ARM = 'HFB-067-AB--var-1';

  function isMobile() {
    return window.matchMedia('(max-width: 959px)').matches;
  }

  function isArmed() {
    if (isMobile()) return true;
    return document.documentElement.classList.contains(ARM) || (document.body && document.body.classList.contains(ARM));
  }

  function bindAccordions(root) {
    if (!root) return;
    root.querySelectorAll('[data-hfb-067-accordion]').forEach(function (item) {
      var trigger = item.querySelector('.hfb-067-nav__accordion-trigger');
      if (!trigger || trigger.getAttribute('data-hfb-067-bound') === '1') return;
      trigger.setAttribute('data-hfb-067-bound', '1');
      trigger.addEventListener('click', function () {
        var open = item.classList.toggle('hfb-067-nav__accordion--open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function closeMenu(e) {
    if (e) e.preventDefault();
    document.body.classList.remove('nav-active');
  }

  function bindClose(root) {
    if (!root) return;
    root.querySelectorAll('[data-hfb-067-close]').forEach(function (btn) {
      if (btn.getAttribute('data-hfb-067-bound') === '1') return;
      btn.setAttribute('data-hfb-067-bound', '1');
      btn.addEventListener('click', closeMenu);
    });
  }

  function bindOverlay() {
    var overlay = document.querySelector('.header-overlay');
    if (!overlay || overlay.getAttribute('data-hfb-067-bound') === '1') return;
    overlay.setAttribute('data-hfb-067-bound', '1');
    overlay.addEventListener('click', closeMenu);
  }

  function blurOpenFocus() {
    var dialog = document.getElementById('mobile-menu-dialog');
    var active = document.activeElement;
    if (!dialog || !active || !dialog.contains(active)) return;
    var hamburger = document.querySelector('.header-hamburger');
    if (hamburger) {
      hamburger.focus({ preventScroll: true });
      return;
    }
    if (typeof active.blur === 'function') active.blur();
  }

  function bindOpenFocus() {
    var body = document.body;
    if (!body || body.getAttribute('data-hfb-067-focus-bound') === '1') return;
    body.setAttribute('data-hfb-067-focus-bound', '1');
    new MutationObserver(function () {
      if (!isArmed() || !body.classList.contains('nav-active')) return;
      syncDrawerTop();
      window.setTimeout(blurOpenFocus, 40);
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  function bindCart(root) {
    if (!root) return;
    root.querySelectorAll('[data-hfb-067-cart]').forEach(function (btn) {
      if (btn.getAttribute('data-hfb-067-bound') === '1') return;
      btn.setAttribute('data-hfb-067-bound', '1');
      btn.addEventListener('click', function () {
        var real = document.querySelector('.header-icons-anchor--cart');
        if (real) real.click();
      });
    });
  }

  function syncDrawerTop() {
    if (!isArmed()) return;
    var header = document.getElementById('shopify-section-header');
    var banner = document.querySelector('.hfb-065-promo-banner');
    var edge = header || banner;
    if (!edge) return;
    var top = Math.round(edge.getBoundingClientRect().bottom);
    if (top > 0) {
      document.documentElement.style.setProperty('--hfb-067-drawer-top', top + 'px');
    }
  }

  function init() {
    if (!isArmed()) return;
    var mobile = document.querySelector('[data-hfb-067-mobile]');
    bindAccordions(mobile);
    bindCart(mobile);
    bindClose(mobile);
    bindOverlay();
    bindOpenFocus();
    syncDrawerTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    init();
    syncDrawerTop();
  });

  if (typeof ResizeObserver !== 'undefined') {
    var watchHeader = function () {
      var headerEl = document.getElementById('shopify-section-header');
      if (!headerEl || headerEl.getAttribute('data-hfb-067-resize') === '1') return;
      headerEl.setAttribute('data-hfb-067-resize', '1');
      new ResizeObserver(syncDrawerTop).observe(headerEl);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchHeader);
    } else {
      watchHeader();
    }
  }

  var observer = new MutationObserver(function () {
    if (isArmed()) init();
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  if (document.body) {
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
